/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: true, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent, .js-fit-vids').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    //CLOSE POPUPS
    $(document).on('click', '.js-close-popup', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    //VIDEO POPUP
    $('.js-popup-video').magnificPopup({
        type: 'inline',
        alignTop: true,
		modal: true,
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		mainClass: 'mfp-fade'
    });

	//SEARCH POPUP
    $('.js-open-search').magnificPopup({
		type:'inline',
		alignTop: true,
		modal: true,
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		mainClass: 'mfp-fade',
		focus : '#s',
		callbacks: {
            // When elemened is focused, some mobile browsers in some cases zoom in
            // It looks not nice, so we disable it:
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#s';
                }
            }
		}
	});

    // ALERTS
    //alert bar
	if( $('.alert-bar') ){
        var alertbar = $('.alert-bar');
        var closealertbar = $('.close-alertbar');

        $(closealertbar).on('click', function(e){
            e.preventDefault();
            //close the alertbar
            alertbar.slideUp();
            // persist the dismissal in a cookie
            document.cookie = closealertbar.data('alert-cookie');
        });
    }

})(jQuery)
